import http from '@/support/plugin/axios'

export const 

getProductByIdAndCompanyIdAndCurrentContactId = (companyId, id) => http.get(`companies/${companyId}/contacts/current/offers/products/${id}`),

activateOfferProductByIdAndCompanyIdAndCurrentContactId = (companyId, id) => http.patch(`companies/${companyId}/contacts/current/offers/products/${id}/activate`)